import { Shape, ExtrudeGeometry, MeshStandardMaterial, Mesh } from "three";
import { useMemo } from "react";

const FencePanel = ({ width, height, position = [0, 0, 0], color, thickness = 0.05, subCategory }) => {

  let aci = 0;
  if (subCategory === 'gunes_kirici'
    || subCategory === 'gunes_kirici2'
    || subCategory === 'yaprak_panel'
  ) {
    aci = -Math.PI / 6;
    thickness = 0.03
  }
  return (
    <mesh
      position={position}
      rotation={[aci, 0, 0]}
    >
      <boxGeometry args={[width, height, thickness]} />
      <meshStandardMaterial color={color} roughness={0.6} metalness={0.4} />
    </mesh>
  );
};

export default FencePanel;